import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React, { useState, useEffect } from 'react';
import { Progress as AntProgress } from 'antd';
import styled from 'styled-components';

var randomNumberBetween = function randomNumberBetween() {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  return Math.floor(Math.random() * end) + start;
};

var ProgressContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n"])));
var Progress = styled(AntProgress)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  top: -0.95rem;\n\n  .ant-progress-inner {\n    background-color: transparent;\n    border-radius: 0;\n  }\n  .ant-progress-bg {\n    border-radius: 0;\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.theme.colors.primary;
});
export default function PageSuspenseFallback() {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      progressPercentage = _useState2[0],
      setProgressPercentage = _useState2[1];

  useEffect(function () {
    var delayedProgress = setTimeout(function () {
      if (progressPercentage < 99) {
        setProgressPercentage(progressPercentage + randomNumberBetween(0, 100 - progressPercentage));
      }
    }, randomNumberBetween(100, 1000));
    return function () {
      return clearTimeout(delayedProgress);
    };
  }, [progressPercentage]);
  return /*#__PURE__*/React.createElement(ProgressContainer, null, /*#__PURE__*/React.createElement(Progress, {
    percent: progressPercentage,
    showInfo: false,
    status: "active"
  }));
}